export type HelpCenterTutorialVideo = {
  id: number;
  title: string;
  description: string;
  videoUrl: string;
};

export type HelpCenterTutorialCategory = {
  path: string;
  title: string;
  videos: HelpCenterTutorialVideo[];
};

export type HelpCenterImportTemplate = {
  id: string;
  title: string;
  description: string;
  href: string;
  downloadName: string;
};

export const HELP_CENTER_HOME_VIDEO = {
  title: 'Conheça o eCustos',
  videoUrl: 'https://player.vimeo.com/video/1087707611',
};

export const HELP_CENTER_TUTORIALS_BY_ROUTE: Record<
  string,
  HelpCenterTutorialCategory
> = {
  '/budgets/tutorial': {
    path: '/budgets/tutorial',
    title: 'Tutorial - Orçamentos',
    videos: [
      {
        id: 1,
        title: 'Começando um novo orçamento',
        description:
          'Veja como começar a criar orçamentos no ecustos agora mesmo.',
        videoUrl: 'https://player.vimeo.com/video/1117906941?h=820b4c784e',
      },
      {
        id: 2,
        title: 'Editando um orçamento',
        description:
          'Gerencie a estrutura do seu orçamento, adicionando ou removendo itens da EAP.',
        videoUrl: 'https://player.vimeo.com/video/1118094053?h=1e8fb26fba',
      },
      {
        id: 3,
        title: 'Alteração global',
        description:
          'Saiba como alterar os preços dos itens do seu orçamento de forma rápida e prática.',
        videoUrl: 'https://player.vimeo.com/video/1116265707?h=a1fa73a9e7',
      },
      {
        id: 4,
        title: 'Duplicar orçamento',
        description:
          'Saiba como duplicar um orçamento existente para facilitar a criação de novos orçamentos.',
        videoUrl: 'https://player.vimeo.com/video/1117912286?h=66ea9be4e3',
      },
      {
        id: 5,
        title: 'Gerando relatórios do orçamento',
        description:
          'Depois de finalizado, você pode emitir relatórios Excel do seu orçamento, prontos para seu uso.',
        videoUrl: 'https://player.vimeo.com/video/347575205',
      },
      {
        id: 6,
        title:
          'Atualização nos itens  do orçamento com base nos preços originais',
        description:
          'Veja como atualizar os valores de seus orçamentos de acordo com os preços da base',
        videoUrl: 'https://player.vimeo.com/video/1055319639',
      },
      {
        id: 7,
        title: `Importar orçamentos`,
        description: `Veja como importar seu orçamento para o eCustos a partir de um arquivo Excel`,
        videoUrl: 'https://player.vimeo.com/video/1204273604?h=8b3b4f38ce',
      },
    ],
  },
  '/budgets/templates/tutorial': {
    path: '/budgets/templates/tutorial',
    title: 'Tutorial - Templates',
    videos: [
      {
        id: 1,
        title: 'Templates',
        description:
          'Veja como utilizar os templates de orçamento oferecidos pela equipe do eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1114892163?h=d5e6b4d251',
      },
    ],
  },
  '/parametric-budgets/tutorial': {
    path: '/parametric-budgets/tutorial',
    title: 'Tutorial - Orçamento Paramétrico',
    videos: [
      {
        id: 1,
        title: 'Criando um orçamento paramétrico',
        description:
          'Veja o passo a passo necessário para criar um orçamento paramétrico.',
        videoUrl: 'https://player.vimeo.com/video/1116244011?h=facfbcf607',
      },
      {
        id: 2,
        title: 'Gerar EAP',
        description:
          'Aprenda a gerar a EAP a partir de um orçamento paramétrico de forma totalmente automática.',
        videoUrl: 'https://player.vimeo.com/video/1116246047?h=9dc62f6752',
      },
    ],
  },
  '/clients/tutorial': {
    path: '/clients/tutorial',
    title: 'Tutorial - Clientes',
    videos: [
      {
        id: 1,
        title: 'Gerenciar clientes',
        description:
          'Veja como criar e gerenciar clientes para seus orçamentos no eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1114888491?h=00f166dacb',
      },
    ],
  },
  '/bases/tutorial': {
    path: '/bases/tutorial',
    title: 'Tutorial - Base própria',
    videos: [
      {
        id: 1,
        title: 'Criando uma base própria',
        description:
          'Aprenda a criar uma base própria para utilizar em seus orçamentos.',
        videoUrl: 'https://player.vimeo.com/video/1116234710?h=8d2db0514d',
      },
      {
        id: 2,
        title: 'Consolidando alterações na base própria',
        description:
          'Após fazer alterações, você precisa consolidá-las para que sejam aplicadas. Veja como fazer isso.',
        videoUrl: 'https://player.vimeo.com/video/1116237965?h=c419f42d4a',
      },
    ],
  },
  '/compositions/tutorial': {
    path: '/compositions/tutorial',
    title: 'Tutorial - Composições',
    videos: [
      {
        id: 1,
        title: 'Criar composição própria',
        description:
          'Neste vídeo você aprenderá a criar uma composição própria para utilizar em seus orçamentos.',
        videoUrl: 'https://player.vimeo.com/video/1116241196?h=9dd947bae1',
      },
      {
        id: 2,
        title: 'Importar composições',
        description:
          'Caso você possua uma base de composições já estabelecida, veja como importá-la para o eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1116251702?h=914fb9d305',
      },
      {
        id: 3,
        title: 'Pesquisar composições',
        description:
          'Veja como pesquisar e filtrar as composições e insumos nas bases disponíveis.',
        videoUrl: 'https://player.vimeo.com/video/1116259475?h=038dbdc804',
      },
    ],
  },
  '/imports/tutorial': {
    path: '/imports/tutorial',
    title: 'Tutorial - Importações',
    videos: [
      {
        id: 1,
        title: 'Importação de composições',
        description:
          'Veja como importar uma planilha de composições para o ecustos.',
        videoUrl: 'https://player.vimeo.com/video/1150151191?h=cd95c381cb',
      },
      {
        id: 2,
        title: `Importar orçamentos`,
        description: `Veja como importar seu orçamento para o eCustos a partir de um arquivo Excel`,
        videoUrl: 'https://player.vimeo.com/video/1204273604?h=8b3b4f38ce',
      },
    ],
  },
  '/configuration/tutorial': {
    path: '/configuration/tutorial',
    title: 'Tutorial - Configurações',
    videos: [
      {
        id: 1,
        title: 'Customizar Excel',
        description:
          'Veja como customizar o Excel gerado pelo eCustos com as suas próprias cores e logotipo.',
        videoUrl: 'https://player.vimeo.com/video/1114883229?h=e7caf16d11',
      },
      {
        id: 2,
        title: 'Gerenciar usuários',
        description:
          'Veja como gerenciar os usuários da sua organização no eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1116247978?h=9e96f5b114',
      },
    ],
  },
  '/inputs/tutorial': {
    path: '/inputs/tutorial',
    title: 'Tutorial - Insumos',
    videos: [
      {
        id: 1,
        title: 'Criar insumos',
        description: 'Veja como criar e gerenciar seus insumos no eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1114887302?h=50b15e91c2',
      },
      {
        id: 2,
        title: 'Importar insumos',
        description: 'Importe insumos da sua base própria para o eCustos.',
        videoUrl: 'https://player.vimeo.com/video/1114889868?h=7480bc78de',
      },
      {
        id: 3,
        title: 'Pesquisar insumos',
        description:
          'Saiba como pesquisar e filtrar insumos nas bases disponíveis',
        videoUrl: 'https://player.vimeo.com/video/1114891429?h=06c99133f0',
      },
    ],
  },
};

export const HELP_CENTER_IMPORT_TEMPLATES: HelpCenterImportTemplate[] = [
  {
    id: 'budget-template',
    title: 'Modelo de importação de orçamento',
    description: 'Baixe a planilha para importar orçamento no formato correto.',
    href: '/files/modelo_importacao_orcamento.xlsx',
    downloadName: 'modelo_importacao_orcamento.xlsx',
  },
  {
    id: 'composition-template',
    title: 'Modelo de importação de serviços',
    description: 'Baixe a planilha para importar serviços próprios.',
    href: '/files/modelo_importacao_composicoes.xlsx',
    downloadName: 'modelo_importacao_composicoes.xlsx',
  },
  {
    id: 'input-template',
    title: 'Modelo de importação de insumos',
    description: 'Baixe a planilha para importar insumos próprios.',
    href: '/files/modelo_importacao_insumos.xlsx',
    downloadName: 'modelo_importacao_insumos.xlsx',
  },
];
